import React, { useState } from 'react';

function Partner() {
    const [inputs, setInputs] = useState({});

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({...values, [name]: value}))
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        console.log(inputs);
    }
    return (
        <div className='container'>
            <div className='partner-container'>
			<br/><br/>
                <h3 className='subheader green-text'>Partner with us</h3>
                <p className='maintext signup-sub'>Fill your data below and we will contact you</p>
				
                <form className='signup' onSubmit={handleSubmit}>
				<label class='subtext'>First Name</label>
                    <input name="firstname" value={inputs.firstname || ""} onChange={handleChange} type="text" className="signup-input" placeholder="Enter your first name" />
                
				<label class='subtext'>Last Name</label>
					<input name="lastname" value={inputs.lastname || ""} onChange={handleChange} type="text" className="signup-input" placeholder="Enter your last name" />
                
				<label class='subtext'>Email</label>
				<input name="email" value={inputs.email || ""} onChange={handleChange} type="email" className="signup-input" placeholder="Enter your email address" />
                    
					<label class='subtext'>Phone number</label>
					<input name="phone" value={inputs.phone || ""} onChange={handleChange} type="number" className="signup-input" placeholder="Enter your phone number" />
					
					<label class='subtext'>Property type</label>
					<input name="propertytype" value={inputs.propertytype || ""} onChange={handleChange} type="text" className="signup-input" placeholder="Enter the property type" />
					
					<label class='subtext'>Property Location</label>
					<input name="propertylocation" value={inputs.propertylocation || ""} onChange={handleChange} type="text" className="signup-input" placeholder="Enter the property location" />
                    
					<label class='subtext'>Is the property furnished ?</label>
					<br/>
					<input name="furnished" value="yes" onChange={handleChange} type="radio" className="radio" />Yes<br/>
					<input name="furnished" value="no" onChange={handleChange} type="radio" className="radio" />No<br/>
					<br/><br/>
					<input type="submit" className='partner-btn' value="Submit"/>
                </form>
                
            </div>
        </div>
    )
}

export default Partner;